import { orderDdd, addOrderApi } from '@/api/order.js'
import { doPay, moviePayApi } from '@/api/pay'
import { getuser } from '@/api/user'
import { getPayInfo, setAddressId, setPayInfo } from '@/utils/Address.js'
import isWeChatWeb from '@/utils/checkWebUserAgent'
import weChatJsApiPay from '@/utils/weChatJsApiPay'
import { judgeUserAgent } from '@/utils/judgeUserAgent'
import router from '@/router'



/*
  pay_goods_type: cake 蛋糕 |  '' 不传为普通支付
*/

// 支付前处理
const  paymentTypeHandle = ({ state, getters, dispatch }, orderInfo) => {
      const type = ['carts_id', 'goods_sn']
      let payType = '' // 支付类型
      let payInfo = '' // 支付信息

      // 蛋糕结算
      if (
        orderInfo.pay_goods_type &&
        orderInfo.pay_goods_type === 'cake'
      ) {
        payType = type[1]
        payInfo =
          getters.getPayInfo.payInfo[0].goods_size[0]

    }
  // 普通结算
  if (!orderInfo.pay_goods_type) {
      if (
        getters.getPayInfo['payType'] ===
        state.paymentType.cart
      ) {
        // 购物车结算
        payType = type[0]
        payInfo = `[${getters.getPayInfo['payInfo']}]`
      }
      // 立即购买结算
      if (
        getters.getPayInfo['payType'] ===
        state.paymentType.buyNow
      ) {
        payType = type[1]
        payInfo = getters.getPayInfo['payInfo'].toString()
      }
  }
    
  return {
    payType,
    payInfo
  }
}

// 加入订单
const orderAdd = async ({
  orderInfo,
  payType,
  payInfo,
  address_id
}) => {
  const {
    distribution_date,
    distribution_time,
    distribution_type,
    cake_addr,
    goods_type
  } = orderInfo

  const result = await addOrderApi({
    [payType]: payInfo,
    address_id: address_id,
    remark: orderInfo.remark || undefined,
    payment_type: orderInfo.paymentType,
    distribution_date: distribution_date || undefined,
    distribution_time: distribution_time || undefined,
    distribution_type: distribution_type || undefined,
    cake_addr: cake_addr || undefined,
    goods_type: goods_type || undefined
  }).catch(err => console.log(err))
  return result.data.data
}

// 跳转到支付平台
/*
  order_type: 1 电影订单
  pay_id: 支付id
*/
function toPaymentPlatform ({ pay_id, order_type = '' }) {
  console.log(55555)
     router.push({
       path: '/paymentPlatform',
       query: {
         pay_id: pay_id,
         order_type: order_type
       }
     })
}

const storageGoodsInfo = {
  payInfo: [],
  payType: ''
}

const state = {
  addressId: '', // 支付地址
  payTpye: '', // 支付方式
  payInfo: [],
  paymentType: {
    cart: 'cart',
    buyNow: 'buyNow'
  }
}

const mutations = {
  SET_ADDRESSID: (state, addressId) => {
    if (addressId) {
      setAddressId(addressId)
      state.addressId = addressId
    }
  },
  GET_ADDRESSID: state => {
      return state.addressId 
  },
  SET_PAYINFO: (state, info) => {
    const { payInfo, payType } = info

    if (payInfo && payType) {
      state.payInfo = payInfo
      state.payTpye = payType

      storageGoodsInfo.payInfo = payInfo
      storageGoodsInfo.payType = payType

      setPayInfo(storageGoodsInfo)
     
    }
  },
    GET_PAYINFO (state) {
   
  }
}

const actions = {
  // 重新支付
  async repay ({ state, getters, dispatch }, info) {
    const { pay_type, pay_id } = info
    if (pay_type === 3) {
      if (judgeUserAgent('weChat') || judgeUserAgent('miniProgram')) {
        // 微信api支付
        return await dispatch('wechatPayByjsApi', info.pay_id)
      } else {
        // 微信h5支付
        await dispatch('wechatPayByH5', info.pay_id)
      }
    } else {
      const payResult = await doPay({
        pay_id: pay_id,
      })
      return payResult.data.data
    }
  },
  // 电影结算
  async moviePay ({ state, getters, dispatch }, info) {
    const result = await moviePayApi({
      order_id: info.orderId,
      payment_type: info.paymentType
    })
    return result.data.data
  },
  async movieOrderPay ({ state, getters, dispatch }, info) {
    if (info.paymentType === 3) {
        toPaymentPlatform({
         pay_id: info.pay_id,
         order_type: 'movie'
       })
      return {
        status: false,
        message: ''
      }
      // if (judgeUserAgent('weChat') || judgeUserAgent('miniProgram')) {
      //   // 微信api支付
      //   return await dispatch('wechatPayByjsApi', info.pay_id)
      // } else {
      //   // 微信h5支付
      //   await dispatch('wechatPayByH5', info.pay_id)
      // }
    } else {
      // 积分/余额支付
      return await dispatch('moviePay', info)
    }
  },
 
  // 结算
  async payOrder ({ state, getters, dispatch }, orderInfo) {
    const { payType, payInfo } = paymentTypeHandle(
      { state, getters, dispatch },
      orderInfo
    )

    let payResult = {
      status: true,
      orderSn: '',
      message: '',
      payCancel: false
    }
    
    const addOrderResult = await orderAdd({
      orderInfo,
      payType,
      payInfo,
      address_id: getters.getAdddreId,
    })
    if (!addOrderResult.status) {
      payResult.status = false
      payResult.message = addOrderResult.message

      return Promise.resolve(payResult)
    }
    // 判断是否还有未支付
    if (
      addOrderResult.orderInfo.payment_type_status !== false
    ) {
      payResult.orderSn = addOrderResult.orderInfo.order_sn
      payResult.message = '支付成功'
      return Promise.resolve(payResult)
    }

    const payId = addOrderResult.orderInfo.payment_type_detail.pay_id

    toPaymentPlatform({
      pay_id: payId
    })

    return {
      status: false,
      message: ''
    }
    
    // const paymentStatus = add
    // for (let i = 0; i < addOrderResult.orderInfo.payment.length; i++) {
    //   const item = addOrderResult.orderInfo.payment[i]
    //   if (Number(item.payType) === 3 && !item.status) {
    //     if (
    //       judgeUserAgent('weChat') ||
    //       judgeUserAgent('miniProgram')
    //     ) {
    //       // 微信api支付
    //       payResult = await dispatch(
    //         'wechatPayByjsApi',
    //         {
    //           pay_id: item.pay_id,
    //           order_sn: addOrderResult.orderInfo.order_sn
    //         }
    //       )
    //     } else {
    //       // 微信h5支付
    //       payResult = await dispatch('wechatPayByH5', item.pay_id)
    //     }
    //   } else {
    //     payResult.status = item.status
    //     payResult.message = payResult.status ? '支付成功' : '支付失败'
    //   }
    // }

    // payResult.orderSn = addOrderResult.orderInfo.order_sn
   
    // return Promise.resolve(payResult)
  },
  // 微信支付 h5
  async wechatPayByH5({state}, pay_id) {
    const result = await doPay({
      pay_id: pay_id
    }).catch(err => console.log(err))
    const { status, payment } = result.data.data
    if (status && payment.pay_data.trade_type === 'MWEB') {
      document.location.href = payment.pay_data.mweb_url
    }
  },
  // 微信支付 微信浏览器
  async wechatPayByjsApi({state}, paload) {
    // 获取openId
    const { order_sn, pay_id } = paload
    let openId = ''
    const openIdResult = await getuser()
    const {
      status: openIdStatus,
      isBindWechat
    } = openIdResult.data.data
    if (openIdStatus && isBindWechat) {
      openId = openIdResult.data.data.openId
    }
    // 调起支付
    const payResult = await doPay({
      pay_id: pay_id,
      openid: openId
    })
    
    const {
      status: payStatus,
      payment
    } = payResult.data.data
    
    if (payStatus) {
      // 唤起微信支付
      const wechatPayResult = await weChatJsApiPay({
        ...payment.pay_data,
        order_sn: order_sn
      }).catch(err => {
        console.log(err)
      })
      return wechatPayResult
    } else {
      return {
        status: false
      }
    }
  }
}

const getters = {
  getAdddreId: state => {
    return state.addressId
    // if (state.addressId) {
    //   return state.addressId
    // } else {
    //   return getAddressId()
    // }
  },
  getPayInfo: state => {
     if (state.payInfo.length === 0) {
       return getPayInfo()
     }
     storageGoodsInfo.payInfo = state.payInfo
     storageGoodsInfo.payType = state.payTpye

     return storageGoodsInfo
  },
  getPayInfo: state => {
    if (state.payInfo && state.payTpye) {
      return {
        payInfo: state.payInfo,
        payType: state.payTpye
      }
    } else {
      return getPayInfo()
    }
  },

  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
